import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    backgroundColor: '#ffffff',
    padding: 15,
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    padding: 10,
    gap: 10,
    borderWidth: 1,
    borderColor: '#000000',
    borderRadius: 10,
    marginBottom: 10,
    alignItems: 'center',
  },
  section30: { width: '30%' },
  section70: {
    width: '70%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
  },
  image: { width: '100%' },
  title: { fontSize: 16, marginBottom: 8, textAlign: 'center' },
  subtitle: { fontSize: 11, textAlign: 'center' },
  tableContainer: {
    borderColor: '#000000',
    borderWidth: 1,
    borderRadius: 5,
  },
  tableHeaderRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderColor: '#000',
    alignItems: 'center',
    minHeight: 20,
    backgroundColor: '#d0d0d0',
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderColor: '#000',
    alignItems: 'center',
    minHeight: 18,
  },
  cellNarrow: {
    width: 30,
    fontSize: 8,
    textAlign: 'center',
    borderRightWidth: 1,
    borderColor: '#000',
    padding: 3,
  },
  cell: {
    flex: 1,
    fontSize: 8,
    textAlign: 'center',
    borderRightWidth: 1,
    borderColor: '#000',
    padding: 3,
  },
  lastCell: {
    width: 60,
    fontSize: 8,
    textAlign: 'center',
    padding: 3,
  },
});

const PDFListadoClientes = ({ list, filtroNivelDesc }) => (
  <Document>
    <Page size="A4" orientation="landscape" style={styles.page}>
      <View style={styles.headerContainer}>
        <View style={styles.section30}>
          <Image src="/images/logo.jpg" style={styles.image} />
        </View>
        <View style={styles.section70}>
          <Text style={styles.subtitle}>Aurelio Muebles</Text>
          <Text style={{ fontSize: 9 }}>"Financiación Amigable a tu Medida"</Text>
          <Text style={styles.subtitle}>Fecha: {new Date().toLocaleDateString()}</Text>
        </View>
      </View>
      <Text style={styles.title}>
        {'Listado de Clientes' + (filtroNivelDesc ? ' — Nivel: ' + filtroNivelDesc : '')}
      </Text>
      <View style={styles.tableContainer}>
        <View style={styles.tableHeaderRow}>
          <Text style={styles.cellNarrow}>ID</Text>
          <Text style={styles.cell}>Nombre</Text>
          <Text style={styles.cell}>Teléfono</Text>
          <Text style={styles.cell}>Dirección</Text>
          <Text style={styles.cell}>Municipio</Text>
          <Text style={styles.cell}>Localidad</Text>
          <Text style={styles.lastCell}>Nivel</Text>
        </View>
        {list && list.map((item, i) => (
          <View
            key={'row-' + i}
            style={i === list.length - 1 ? { ...styles.tableRow, borderBottomWidth: 0 } : styles.tableRow}
          >
            <Text style={styles.cellNarrow}>{item.idCliente}</Text>
            <Text style={styles.cell}>{item.nombre}</Text>
            <Text style={styles.cell}>{item.telefono}</Text>
            <Text style={styles.cell}>{item.direccion}</Text>
            <Text style={styles.cell}>{item.municipioNombre || ''}</Text>
            <Text style={styles.cell}>{item.localidadNombre || ''}</Text>
            <Text style={styles.lastCell}>{item.nivel ? item.nivel.descripcion : ''}</Text>
          </View>
        ))}
      </View>
    </Page>
  </Document>
);

export default PDFListadoClientes;
